import HeaderHero from "./HeaderHero";
import JotFormComponent from "../../components/form/JotFormEmbed";
import "./EnrollPage.scss";
import React from "react";

function EnrollPage() {
	React.useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<>
			<div>
				<HeaderHero
					title="CHOOSE YOUR PACKAGES"
					subtitle="Select your desired media budgets and packages."
				/>
				<div className="enroll-page">
					<JotFormComponent />
				</div>
			</div>
		</>
	);
}

export default EnrollPage;
